import { render, staticRenderFns } from "./ModalTestStart.vue?vue&type=template&id=067aeeca&scoped=true"
import script from "./ModalTestStart.vue?vue&type=script&lang=js"
export * from "./ModalTestStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067aeeca",
  null
  
)

export default component.exports